<div class="filters border-bottom-1 border-grey p-2">
  <div class="row">
    <div class="col-3 form-label-row">
      <span translate>accounts.gl_code</span>
      <div class="input-group">
        <input type="text" name="filterGLCode" id="filterGLCode" class="form-control" maxLength="10"
          placeholder="" [(ngModel)]="accountFilter.accountTypeCode" (ngModelChange)="timeoutToTrigger()">
          @if (accountFilter.accountTypeCode) {
            <i class="pi pi-times remove-button"
            (click)="accountFilter.accountTypeCode = undefined; triggerFilterAccount()"></i>
          }
        </div>
      </div>
      <div class="col-3 form-label-row">
        <span translate>accounts.gl_name</span>
        <div class="input-group">
          <input type="text" name="filterGLAccountName" id="filterGLAccountName" maxLength="50"
            class="form-control" placeholder="" [(ngModel)]="accountFilter.accountTypeName" (ngModelChange)="timeoutToTrigger()">
            @if (accountFilter.accountTypeName) {
              <i class="pi pi-times remove-button"
              (click)="accountFilter.accountTypeName = undefined; triggerFilterAccount()"></i>
            }
          </div>
        </div>
        <div class="col-3 form-label-row">
          <span translate>accounts.number</span>
          <div class="input-group">
            <input type="text" name="filterAccountNumber" id="filterAccountNumber" maxLength="34"
              class="form-control" placeholder="" [(ngModel)]="accountFilter.number" (ngModelChange)="timeoutToTrigger()">
              @if (accountFilter.number) {
                <i class="pi pi-times remove-button"
                (click)="accountFilter.number = undefined; triggerFilterAccount()"></i>
              }
            </div>
          </div>
          <div class="col-3 form-label-row">
            <span translate>accounts.name</span>
            <div class="input-group">
              <input type="text" name="filterAccountName" id="filterAccountName" maxLength="50"
                class="form-control" placeholder="" [(ngModel)]="accountFilter.name" (ngModelChange)="timeoutToTrigger()">
                @if (accountFilter.name) {
                  <i class="pi pi-times remove-button"
                  (click)="accountFilter.name = undefined; triggerFilterAccount()"></i>
                }
              </div>
            </div>
            <div class="col-3 form-label-row">
              <span translate>customer_mngt.customer_id</span>
              <div class="customer-search-group form-group input-group">
                <input type="text" name="filterCustomerId" id="filterCustomerId" maxLength="30"
                  class="form-control" placeholder="" [(ngModel)]="accountFilter.customerAccountNumber" (ngModelChange)="timeoutToTrigger()">
                  <i class="fa fa-search advanced-search-box" aria-hidden="true" pTooltip="Advanced Search" tooltipStyleClass="tooltip-class"
                  (click)="showAdvancedSearch()"></i>
                  @if (accountFilter.customerAccountNumber) {
                    <i class="pi pi-times remove-button-search"
                    (click)="accountFilter.customerAccountNumber = undefined; triggerFilterAccount()"></i>
                  }
                </div>
              </div>
              <div class="col-3 form-label-row">
                <span translate>accounts.branch</span>
                <div class="input-group">
                  <p-dropdown [options]="branchCodeList" name="filterBranchId" placeholder="{{'placeholders.select_branch' | translate}}"
                    optionLabel="name" optionValue="code" (onChange)="triggerFilterAccount()" [(ngModel)]="accountFilter.branchCode"
                    class="w-full" [style]="{'width': '100%'}" appendTo="body">
                  </p-dropdown>
                  @if (accountFilter.branchCode) {
                    <i class="pi pi-times remove-button-dropdown"
                    (click)="accountFilter.branchCode = undefined; triggerFilterAccount()"></i>
                  }
                </div>
              </div>
              <div class="col-3 form-label-row">
                <span translate>common.currency</span>
                <div class="input-group">
                  <p-dropdown [options]="currencyList" name="filterCurrency" placeholder="{{'placeholders.select_currency' | translate}}"
                    optionLabel="isoCode" optionValue="isoCode" (onChange)="triggerFilterAccount()" [(ngModel)]="accountFilter.currency"
                    class="w-full" [style]="{'width': '100%'}" appendTo="body">
                  </p-dropdown>
                  @if (accountFilter.currency) {
                    <i class="pi pi-times remove-button-dropdown"
                    (click)="accountFilter.currency = undefined; triggerFilterAccount()"></i>
                  }
                </div>
              </div>
              @if (isFilterAccount) {
                <div class="col-3" style="align-items: end; display: flex;">
                  <button type="button" class="btn btn-primary ml-3 w-80 blue-btn"
                    (click)="resetFilterAccount()" aria-hidden="true" aria-label="Close">
                    <span translate>coa.tree-view</span>
                  </button>
                </div>
              }
            </div>
          </div>
          @if (displaySearchDialog) {
            <app-advanced-search-customer-popup [displaySearchDialog]="displaySearchDialog"
              (onSubmit)="onSubmitSelectedCustomer($event)" (onCancel)="hideAdvancedSearch()">
            </app-advanced-search-customer-popup>
          }